var ImagerJs = {
  /**
   * @namespace ImagerJs.plugins
   * @memberof ImagerJs
   */
  plugins: {},
  /**
   * @namespace ImagerJs.util
   * @memberof ImagerJs
   */
  util: {},

  /**
   * @namespace ImagerJs.translations
   * @memberof ImagerJs
   */
  translations: {}
};